import { Directive, ElementRef, Input } from '@angular/core';
import { getCurrentDomain } from '../helpers/helper-functions';

@Directive({
  selector: '[appDomain]'
})
export class DomainDirective {

  @Input() domain!: string;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    const currentDomain = getCurrentDomain();

    if (this.domain != currentDomain && window.location.hostname != 'localhost') {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }

}
